import {
  FileExcelOutlined,
  FileImageOutlined,
  FilePdfOutlined,
  FileTextOutlined,
  FileWordOutlined,
} from '@ant-design/icons';
import { Flex, Typography } from 'antd';
import { documentsApi } from '@api/documents/documentsApi';
import { EvidenceFileItem } from '@api/brokerCases/types';
import { formatDateTimeLondonNoTz } from '@utils/dates';
import { openBlobInNewTab } from '@pages/ApplicationDetailsPage/helpers';

export interface IEvidenceUploadedFileItemProps {
  file: EvidenceFileItem;
}

function getFileIcon(fileName: string) {
  const extension = fileName.split('.').pop()?.toLowerCase();

  switch (extension) {
    case 'pdf':
      return <FilePdfOutlined className='text-md leading-none text-red-500' />;
    case 'doc':
    case 'docx':
      return <FileWordOutlined className='text-md leading-none text-blue-500' />;
    case 'xls':
    case 'xlsx':
    case 'csv':
      return <FileExcelOutlined className='text-md leading-none text-green-500' />;
    case 'jpg':
    case 'jpeg':
    case 'png':
      return <FileImageOutlined className='text-md leading-none text-purple-500' />;
    default:
      return <FileTextOutlined className='text-md leading-none text-blue-500' />;
  }
}

export const EvidenceUploadedFileItem = ({ file }: IEvidenceUploadedFileItemProps) => {
  const descriptionText = typeof file.description === 'string' ? file.description.trim() : '';
  const hasDescription = descriptionText.length > 0;
  const handleClick = () => {
    documentsApi.getFileById(file.id).then(res => {
      openBlobInNewTab(res, file.originalFileName);
    });
  };

  return (
    <Flex
      align='center'
      className='cursor-pointer rounded-lg bg-gray-100 py-3 px-4 gap-3 transition-colors hover:bg-gray-200'
      onClick={handleClick}
    >
      <div className='flex size-8 shrink-0 items-center justify-center rounded-lg bg-white p-2'>
        {getFileIcon(file.originalFileName)}
      </div>
      <Flex vertical>
        {hasDescription ? (
          <Typography.Text className='text-xs font-medium leading-5 text-black/90'>{descriptionText}</Typography.Text>
        ) : null}
        <Typography.Text className='text-xs font-normal leading-5'>{file.originalFileName}</Typography.Text>
        <Typography.Text className='text-xs font-normal leading-4 text-gray-400'>
          {formatDateTimeLondonNoTz(file.uploadedAt)}
        </Typography.Text>
      </Flex>
    </Flex>
  );
};
